export
{
	default as templateParser
}
from './modules/template parser'

export
{
	default as templateFormatter
}
from './modules/template formatter'

export
{
	default as ReactInput
}
from './modules/ReactInput'

export
{
	default as parseDigit
}
from './modules/parse digit'

export
{
	default as parse
}
from './modules/parse'

export
{
	default as format
}
from './modules/format'

export
{
	onChange,
	onPaste,
	onCut,
	onKeyDown
}
from './modules/input control'


//////////////////
// WEBPACK FOOTER
// /app/node_modules/input-format/index.js
// module id = 801
// module chunks = 1 2 3 4